const FLAG_API = 'https://flagcdn.com/20x15';

export default function Stats({ decisions }) {
  const total = decisions.length;

  // Top pays — uniquement les entrées avec un vrai code pays ISO (2 lettres)
  const byCountry = {};
  for (const d of decisions) {
    const cc = d.country;
    if (cc && /^[A-Z]{2}$/.test(cc)) {
      byCountry[cc] = (byCountry[cc] || 0) + 1;
    }
  }
  const topCountries = Object.entries(byCountry).sort((a,b) => b[1]-a[1]).slice(0, 5);

  // Top scenario
  const byScenario = {};
  for (const d of decisions) {
    const s = d.scenario || 'inconnu';
    byScenario[s] = (byScenario[s] || 0) + 1;
  }
  const topScenario = Object.entries(byScenario).sort((a,b) => b[1]-a[1])[0];

  // Stats origine
  const capi = decisions.filter(d => d.origin === 'CAPI' || d.origin === 'lists').length;
  const local = decisions.filter(d => d.origin === 'crowdsec' || d.origin === 'cscli').length;

  const card = {
    background: 'var(--bg2)',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    padding: '1.2rem 1.5rem',
  };

  return (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:'1rem', marginBottom:'2rem' }}>
      {/* Total */}
      <div style={{ ...card, borderLeft: '3px solid var(--accent)' }}>
        <div style={{ fontFamily:'var(--font-mono)', fontSize:'2rem', fontWeight:600, color:'var(--accent)' }}>{total}</div>
        <div style={{ color:'var(--muted)', fontSize:'0.8rem', marginTop:'0.2rem' }}>IP bannies actives</div>
        {(capi > 0 || local > 0) && (
          <div style={{ marginTop:'0.5rem', display:'flex', gap:'0.5rem', flexWrap:'wrap' }}>
            {local > 0 && <span style={{ fontFamily:'var(--font-mono)', fontSize:'0.72rem', background:'rgba(232,71,63,0.15)', color:'var(--accent)', borderRadius:'4px', padding:'0.1rem 0.4rem' }}>local {local}</span>}
            {capi > 0 && <span style={{ fontFamily:'var(--font-mono)', fontSize:'0.72rem', background:'rgba(90,96,112,0.2)', color:'var(--muted)', borderRadius:'4px', padding:'0.1rem 0.4rem' }}>CAPI {capi}</span>}
          </div>
        )}
      </div>

      {/* Top pays */}
      <div style={{ ...card, gridColumn: 'span 2' }}>
        <div style={{ color:'var(--muted)', fontSize:'0.75rem', marginBottom:'0.8rem', textTransform:'uppercase', letterSpacing:'0.05em' }}>Top pays</div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:'0.5rem' }}>
          {topCountries.map(([cc, count]) => (
            <div key={cc} style={{ display:'flex', alignItems:'center', gap:'0.4rem', background:'var(--bg3)', borderRadius:'4px', padding:'0.3rem 0.6rem', fontSize:'0.8rem' }}>
              <img src={`${FLAG_API}/${cc.toLowerCase()}.png`} alt={cc} style={{ width:20, height:15, borderRadius:2 }} onError={e => e.target.style.display='none'} />
              <span style={{ fontFamily:'var(--font-mono)' }}>{cc}</span>
              <span style={{ color:'var(--accent)', fontWeight:700 }}>{count}</span>
            </div>
          ))}
          {topCountries.length === 0 && <span style={{ color:'var(--muted)', fontSize:'0.8rem' }}>Aucun ban local avec pays</span>}
        </div>
      </div>

      {/* Top scenario */}
      <div style={card}>
        <div style={{ color:'var(--muted)', fontSize:'0.75rem', marginBottom:'0.4rem', textTransform:'uppercase', letterSpacing:'0.05em' }}>Scénario principal</div>
        {topScenario ? (
          <>
            <div style={{ fontFamily:'var(--font-mono)', fontSize:'0.8rem', color:'var(--text)', wordBreak:'break-all' }}>{topScenario[0]}</div>
            <div style={{ color:'var(--accent)', fontWeight:700, marginTop:'0.2rem' }}>{topScenario[1]} bans</div>
          </>
        ) : <span style={{ color:'var(--muted)' }}>—</span>}
      </div>
    </div>
  );
}
